import React from 'react';
import { Typography, Box, Link } from '@mui/material';

interface UrlActionProps {
    actionValue: any[];
    heading?: string;
}

const UrlAction: React.FC<UrlActionProps> = ({ actionValue, heading }) => {
    if (!actionValue || actionValue.length === 0) {
        return <Typography>No URL available.</Typography>;
    }

    return (
        <>
            {actionValue.map((value, index) => {
                const title = value?.config_details?.value?.title || 'URL';
                const description = value?.config_details?.value?.description;
                const urlValue = value?.output || value?.url || '';

                return (
                    <div
                        key={value.id || index}
                        style={{ display: 'flex', marginBottom: '10px', alignItems: 'center' }}
                    >
                        <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
                            {title}:
                        </Typography>
                        {urlValue ? (
                            <Link
                                href={urlValue}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: '#1976d2',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                {urlValue}
                            </Link>
                        ) : (
                            <Typography sx={{ fontStyle: 'italic', color: 'gray' }}>
                                No URL provided
                            </Typography>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default UrlAction;
